import React from "react"

import Calendar from "./calendar"

const Program = ({ activity }) => {
  const calendarIds = {
    aventyrarscout: "m4pooli8t91vfac7qu7l2objs0@group.calendar.google.com",
    barnkor:
      "c_a0875a4372043d0fb38b49308b0c6af3a360be7248d5d7f42705bf17da6d6b7a@group.calendar.google.com",
    tonar: "28f73glomdfqrtuuqneb4ctj50@group.calendar.google.com",
    koren:
      "c_4bf2526ee829aef818855096934c1ac892200e58193eedc15d72ed95fd7cd2ff@group.calendar.google.com",
  }
  const calendarId = calendarIds[activity]

  const headings = {
    aventyrarscout: "Program för äventyrarscouterna",
    barnkor: "Program",
  }
  const heading = headings[activity]

  return (
    <>
      <h2>{heading}</h2>
      <Calendar
        className="program"
        calendarId={calendarId}
        dateFormat='{"weekday":"short","month":"numeric","day":"numeric"}'
      />
    </>
  )
}

export default Program
